export const AboutSection = ({IMAGE_PATH, onImageClick, onUserClick, onTaskClick}) => {
      
    return (
        <>
            <section className="about-section"  style={{backgroundImage: `url(${IMAGE_PATH}/about_frame.svg);background-repeat: no-repeat`}}>
                    <div className="container pt-4 pb-3">
                        <div className="row pt-4" id="about2a">
                            <div className="col-sm-5" id="about2">
                                <img className="image_about" src={`${IMAGE_PATH}/about.jpg`} alt="about.jpg" />
                            </div>
                            <div className="col-sm-7 mt-5" id="about1">
                                <h1 className="mb-3">About <span style={{color:'#00675B'}}>Collaborate with Government</span></h1>
                                <p id="work11">Collaborate with Government is an innovative initiative that empowers students and coding enthusiasts to contribute their skills to real-world government projects. By collaborating on key digital initiatives, participants play a vital role in shaping the future of e-governance in India. Our mission is to bridge the gap between education and practical application, allowing young developers to work on impactful projects that directly improve public services and infrastructure.</p>
                                <ul id="Engaged_1" className="row">
                                    <li className="col-sm-6" onClick={onUserClick}>
                                        <img src={`${IMAGE_PATH}/user_manual_v1.png`} alt="user_manual_v1.png"/>
                                        <h6 className="align-self-center"><span style={{color:'#00675B'}}>User Manual for 
                                            Contributor</span></h6>
                                    </li>

                                    <li className="col-sm-6" onClick={onTaskClick}>
                                        <img src={`${IMAGE_PATH}/user_manual_v1.png`} alt="user_manual_v1.png"/>
                                        <h6 className="align-self-center "><span style={{color:'#00675B'}}>User Manual for Task Creator</span></h6>
                                    </li>

                                    <li className="col-sm-6" onClick={onImageClick}>
                                        <img src={`${IMAGE_PATH}/user_manual_v1.png`} alt="user_manual_v1.png"/>
                                        <h6 className="align-self-center border-0"><span style={{color:'#00675B'}}>Standard Operating 
                                            Procedure (SOP)</span></h6>
                                    </li>
                               </ul>
                            </div>
                        </div>
                    </div>
                </section>
        </>
    )
}